const MIN_DIGITS = 8;
const MAX_DIGITS = 15;

/**
 * Strip to digits only (E.164 body without +).
 * @param {string | null | undefined} value
 * @returns {string}
 */
export function digitsOnly(value) {
  return String(value ?? "").replace(/\D/g, "");
}

/**
 * Build https://wa.me/{internationalDigits} from a single E.164-ish string.
 * Returns null if digit count is outside a practical E.164 range.
 *
 * @param {string | null | undefined} e164
 * @returns {string | null}
 */
export function buildWhatsAppMeUrlFromE164(e164) {
  const digits = digitsOnly(e164);
  if (digits.length < MIN_DIGITS || digits.length > MAX_DIGITS) {
    return null;
  }
  return `https://wa.me/${digits}`;
}
